import { ReactNode } from 'react';

import { Box } from '@mui/material';

interface TabPanelProps {
  children: ReactNode;
  value: number | string;
  index: number | string;
  [key: string]: unknown;
}

export const TabPanel = ({
  children,
  value,
  index,
  ...other
}: TabPanelProps) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};
